import Icon from '../components/Icon.vue'

Icon.register({
  'place-of-worship': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M620.6 366.5c10.7 4.6 19.4 17.8 19.4 29.4v100c0 8.8-7.2 16-16 16h-112v-192zM0 396c0-11.6 8.7-24.8 19.4-29.4l108.6-46.5v192h-112c-8.8 0-16-7.2-16-16v-100zM464.5 246.7c9.6 5.8 15.5 16.2 15.5 27.4v237.9h-96v-96c0-35.3-28.7-64-64-64s-64 28.7-64 64v96h-96v-237.9c0-10 7-22.3 15.5-27.4l48.5-29.1v-115c0-8.5 3.4-16.6 9.4-22.6l75.3-75.3c6.2-6.3 16.4-6.3 22.6 0l75.3 75.3c6 6 9.4 14.1 9.4 22.6v115z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/place-of-worship.js
// module id = 1640
// module chunks = 0